<template>
  <div class="row-center-flex-style sth-breadcrumb">
    <el-breadcrumb class="sth-breadcrumb-inner-style">
      <el-breadcrumb-item v-for="item in $route.meta" :key="item">{{ item }}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-button-group class="sth-breadcrumb-button-group">
      <slot></slot>
    </el-button-group>
    <div class="sth-breadcrumb-span">
      <slot name="spanGroup"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "Breadcrumb",
  data() {
    return {

    };
  },
  computed: {

  },
  components: {

  },
  props: [],
}

</script>
<style lang="scss">
//面包屑内层调整flex交叉轴居中样式
.sth-breadcrumb-inner-style {
  margin-top: -25px;
}

//面包屑内层调整Tab的按钮组样式
.sth-breadcrumb-button-group {
  margin-left: 48px;
  margin-top: -25px;
}

.sth-breadcrumb-span{
  margin-top: -25px;
  color: red;
  font-size: 14px;
  margin-right: 28px;
  margin-left: auto
}

</style>



// WEBPACK FOOTER //
// src/components/breadcrumb/breadcrumb.vue